import React from 'react'
import TopSection from '../components/TopSection'
import EmpowerSection from '../components/EmpowerSection'
import LeadSection from '../components/LeadSection'
import ControlSection from '../components/ControlSection'
import OverlapSection from '../components/OverlapSection'
import MultiStackScroll from '../components/MultiStackScroll'
import EmployeeScroll from '../components/EmployeeScroll'
import QuoteInvoiceSection from '../components/QuoteInvoiceSection'
import NavbarComponent from '../components/NavbarComponent'
import FooterSection from '../components/FooterSection'
import PaymentSection from '../components/PaymentSection'


function FeaturesPage() {
    return (
        <>
            <div
                style={{
                    backgroundColor: "#f9fafb",
                }}
            >
                <NavbarComponent />
            </div>
            <TopSection />

            <EmpowerSection />
            <LeadSection />
            <ControlSection />
            {/* <FeatureSection /> */}
            <OverlapSection />
            <MultiStackScroll />
            <EmployeeScroll />
            <QuoteInvoiceSection />
            <PaymentSection />

            <FooterSection />
        </>
    )
}

export default FeaturesPage
